import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-after-sanction',
  templateUrl: './after-sanction.component.html',
  styleUrls: ['./after-sanction.component.scss'],
})
export class AfterSanctionComponent {
  constructor(private router: Router, private util: UtilService) {}
  tickImage = 'assets/images/icons/tick_filled.svg';
  tabs!: string;
  steps!: number;
  conntent!: string;
  title!: string;
  get loanDetains(): any{
    return this.util.loanDetails || {};
  }
  ngOnInit() {
    this.util.getProducts().then(()=>{
      this.getUrlTab();
    });
    
  }
  getUrlTab() {
    switch (true) {
      case this.router.url.includes('/key-fact-statement'):
        this.tabs = 'key-fact-statement';
        this.steps = 1;
        this.title = 'Key Fact Statement';
        this.conntent =
          'A two line statement for what does the Key Fact Statement stands for';
        break;
      case this.router.url.includes('/application-letter'):
        this.tabs = 'application-letter';
        this.steps = 2;
        this.title = 'Application Letter';
        this.conntent =
          'We need everyone to sign the application letter to proceed further.';
        break;
      case this.router.url.includes('nach-mandate'):
        this.tabs = 'nach-mandate';
        this.steps = 3;
        this.title = 'Please Complete the NACH Mandate';
        this.conntent =
          'The bank account that you selected to repay the loan is the following.';
        break;
    }
    // return this.router.url;
  }
  gotoHome() {
      this.util.route('home');
  }
}
